import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiProviderDeletionFailedAction = {
	type: 'AI_PROVIDER_DELETION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiProviderDeletionFailedAction => ({
	type: 'AI_PROVIDER_DELETION_FAILED',
	payload,
});
